import type { ShapeData } from '@/lib/shapes/types/shape-data'
import type { computeDimOverlayGeom } from '../helpers/dim-overlay-geom'

const MASK_ID_PREFIX = {
  'node-edit': 'node-edit-dim-mask',
  crop: 'crop-dim-mask',
} as const

/**
 * Edit-mode dim overlay — fades the entire artboard (pasteboard) so the shape being path-edited
 * or cropped stands out. A mask cuts a rotated hole over the shape's own bounds so the shape and
 * its image never render with any dim/shadow on them, regardless of paint order relative to the
 * shape's live rendering. Node edit and crop draw the same overlay under their own mask id.
 */
export function EditModeDimOverlay({
  variant,
  shape,
  geom,
}: {
  variant: keyof typeof MASK_ID_PREFIX
  shape: ShapeData
  geom: NonNullable<ReturnType<typeof computeDimOverlayGeom>>
}) {
  const maskId = `${MASK_ID_PREFIX[variant]}-${shape.id}`

  return (
    <svg
      className="absolute pointer-events-none"
      style={{
        left: geom.left,
        top: geom.top,
        width: geom.size,
        height: geom.size,
        zIndex: 54,
      }}
    >
      <defs>
        <mask id={maskId}>
          <rect x={0} y={0} width={geom.size} height={geom.size} fill="white" />
          <rect
            x={geom.holeX}
            y={geom.holeY}
            width={shape.width}
            height={shape.height}
            transform={geom.rotTransform}
            fill="black"
          />
        </mask>
      </defs>
      <rect
        x={0}
        y={0}
        width={geom.size}
        height={geom.size}
        fill="#ffffff"
        opacity={0.75}
        mask={`url(#${maskId})`}
      />
    </svg>
  )
}
